import React, { useEffect, useState } from 'react';
import { addSpace } from '../../Components/Tools';
import ApexCharts from 'react-apexcharts';
import axios from 'axios';
import qs from 'qs';

function BilanAcDscRecues(props)
{
    const [series, setSeries] = useState(undefined)
    const [options, setOptions] = useState(undefined)

    useEffect(() => {

        var filename = "Attribution de compensation et dotation de solidarité communautaire reçues";
        if (props.user.budget_annexe === '1' && (props.user.nomen === 'M57' || props.user.nomen === 'M14')) {
            filename = "Prise en charge du deficit du BA par le budget principal (75822)";
        }
        else if (props.user.budget_annexe === '1' && (props.user.nomen === 'M4' || props.user.nomen === 'M41' || props.user.nomen === 'M43' || props.user.nomen === 'M49')) {
            filename = "Subventions d'exploitations & exceptionnelles ";
        }

        var ComEpci = null;
        if (props.user.id_organisme_type === '1') {
            ComEpci = 'Com';
        }
        else if (props.user.id_organisme_type === '2') {
            ComEpci = 'Epci';
        }
        else if (props.user.id_organisme_type === '3') {
            ComEpci = 'Com';
        }

        /* Initialisation des options avec les années */
        var option_tmp = {
            chart: {
                toolbar: {
                    show: props.download?true:false,
                    export: {
                        svg: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        png: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                        csv: {
                          filename: filename.replace("'", '_').replace("/", '_').replace(".", ''),
                        },
                    },
                },
                type: 'bar',
            },
            title: {
                text: filename
            },
            xaxis: {
                categories: props.annees
            },
            yaxis: {
                labels: {
                  formatter: function (value) {
                    return addSpace(Math.round(value*100)/100, true) + " €";
                  }
                },
            },
            dataLabels: {
                formatter: () => {
                    return '';
                }
            },
            plotOptions: {
                bar: {
                    borderRadius: 4
                },
            },
            fill: {
              opacity: 1
            }
        }
        setOptions(option_tmp)

        axios.post('https://app-slfinance.fr/api/graph.php', qs.stringify({
        	'AcDscRecues': true,
            'ComEpci': ComEpci,
            'id_budget': props.user.id_budget,
            'annees': props.annees,
            'hypothese': 'R',
            'ba': props.user.budget_annexe,
            'nomen': props.user.nomen
        }))
        .then(async (res) => {
            if (props.user.budget_annexe === '0') {
                await setSeries([{
                    name: "Attribution de compensation",
                    data: res.data[0],
                    color: '#8e44ad',
                    type: 'bar',
                },{
                    name: "Dotation de solidarité reçue",
                    data: res.data[1],
                    color: '#ff7979',
                    type: 'bar'
                }])
            }
            else if (props.user.budget_annexe === '1' && (props.user.nomen === 'M57' || props.user.nomen === 'M14')) {
                await setSeries([{
                    name: filename,
                    data: res.data[0],
                    color: '#8e44ad',
                    type: 'bar',
                }])
            }
            else if (props.user.budget_annexe === '1' && (props.user.nomen === 'M4' || props.user.nomen === 'M41' || props.user.nomen === 'M43' || props.user.nomen === 'M49')) {
                await setSeries([{
                    name: "Subventions d'exploitation (74)",
                    data: res.data[0],
                    color: '#8e44ad',
                    type: 'bar',
                },{
                    name: "Subventions exceptionnelles (774)",
                    data: res.data[1],
                    color: '#ff7979',
                    type: 'bar'
                }])
            }
        })
    }, [])


	return (
		<div style={{margin: 5}}>
            {options && series?
			<ApexCharts
                series={series}
                options={options}
                width={'100%'}
                height={props.height?props.height:400}
                type="bar"
            />:null}
		</div>
	)
}

export default BilanAcDscRecues;
